import { render, staticRenderFns } from "./recommendation-card.vue?vue&type=template&id=eef6e0d6&scoped=true"
import script from "./recommendation-card.vue?vue&type=script&lang=js"
export * from "./recommendation-card.vue?vue&type=script&lang=js"
import style0 from "./recommendation-card.vue?vue&type=style&index=0&id=eef6e0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef6e0d6",
  null
  
)

export default component.exports